import { usePDFStore } from '../../../stores/pdf.store'
import { FormField } from './Field'

export const FieldsFormLayer = () => {
  const focusedBlock = usePDFStore((state) => state.focusedBlock)
  const fields = usePDFStore((state) => state.fields)

  return (
    <div>
      {fields.map((field, index) => (
        <FormField key={field.id} field={field} index={index} />
      ))}
    </div>
  )
}
